/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

import { observable, computed, action } from "mobx";
import AppStoreBase from "bundle/store/AppStore";
import ServiceRegistry from "bundle/util/ServiceRegistry";
import Events from "bundle/constants/Events";
import { isMobileBrowser } from "bundle/util/AppUtil";

export default class AppStore extends AppStoreBase {
    @observable isValidLicense = true;

    autoFSStopped = false;

    @observable legalDialogOpen = false;

    @observable licenseErrorPopupOpen = false;

    @observable licenseErrorPopupDismissed = false;

    @action setLegalDialogOpen(value) {
        this.legalDialogOpen = value;
    }

    @action setLicenseErrorPopupOpen() {
        this.licenseErrorPopupOpen = true;
    }

    @action setLicenseErrorPopupDismissed() {
        this.licenseErrorPopupDismissed = true;
    }

    @action setInFullScreen(value) {
        if (this.inFullScreen !== value) {
            ServiceRegistry.getService("CommentsApi").toggleCommentsPanel(false);
            super.setInFullScreen(value);
            if (!value) {
                this.autoFSStopped = true;
            }
        }
    }

    @action setSearchOpen(value) {
        this.searchOpen = value;
    }

    @action setValidLicense(value) {
        this.isValidLicense = value;
    }

    setAppReady(value) {
        // App can't be set back to not ready and it can be ready only once.
        if (value && !this.isAppReady) {
            this.isAppReady = true;
            ServiceRegistry.getService("AnalyticsProviderService")
                .logInitialPresetEvent(this.configStore.getActionConfigDiff());
            ServiceRegistry.getService("EventsService").sendEvent(Events.APP_RENDERING_DONE);
        }
    }

    @computed get adjustSearchUI() {
        const previewConfig = this.configStore.getActionConfig("preview");
        if (this.configStore.getConfig().showTopBar
            && (!isMobileBrowser() || this.enableModernViewer)) {
            if ((previewConfig.showAnnotationTools && this.editAllowed)
                || (this.enableModernViewer && (this.isFWPreset || this.isLBPreset))) {
                return previewConfig.adjustSearchUI;
            }
        } else if (this.isSizedPreset) {
            return this.enableModernViewer && (this.inFullScreen || isMobileBrowser());
        }
        return false;
    }

    @action setIsDirty(bool) {
        this.isDirty = bool;
    }

    @action setFileStatus(status) {
        this.fileStatus = status;
    }

    @action setEditAllowed(value) {
        this.editAllowed = value;
    }
}
